import { type IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function AccountCredit({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <AccountCredit.Outline {...props} />
  ) : (
    <AccountCredit.Solid {...props} />
  );
}

AccountCredit.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

AccountCredit.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/* Secondary (lighter) paths - person head and credit circle background */}
        <path
          d="M8.99708 12.584C11.9351 12.584 14.2891 10.229 14.2891 7.292C14.2891 4.355 11.9351 2 8.99708 2C6.06008 2 3.70508 4.355 3.70508 7.292C3.70508 10.229 6.06008 12.584 8.99708 12.584Z"
          className="icon-secondary"
        />
        <path
          d="M22.625 17C22.625 19.5549 20.5544 21.625 18 21.625C15.4456 21.625 13.375 19.5549 13.375 17C13.375 14.4461 15.4456 12.375 18 12.375C20.5544 12.375 22.625 14.4461 22.625 17Z"
          className="icon-secondary"
        />
        {/* Primary (darker) paths - dollar sign and person body */}
        <path
          d="M18.1258 18.496C18.3638 18.468 18.5438 18.39 18.6658 18.262C18.7898 18.134 18.8518 17.969 18.8518 17.767C18.8518 17.681 18.8358 17.606 18.8038 17.542C18.7718 17.478 18.7278 17.422 18.6718 17.374C18.6178 17.326 18.5528 17.285 18.4768 17.251C18.4008 17.215 18.3188 17.182 18.2308 17.152L18.1258 18.496ZM17.9788 15.193C17.8588 15.205 17.7558 15.23 17.6698 15.268C17.5838 15.304 17.5128 15.349 17.4568 15.403C17.4008 15.455 17.3598 15.514 17.3338 15.58C17.3078 15.646 17.2948 15.716 17.2948 15.79C17.2948 15.874 17.3098 15.948 17.3398 16.012C17.3698 16.076 17.4108 16.133 17.4628 16.183C17.5168 16.231 17.5798 16.274 17.6518 16.312C17.7238 16.348 17.8018 16.382 17.8858 16.414L17.9788 15.193ZM18.2788 16.54C18.4228 16.584 18.5648 16.633 18.7048 16.687C18.8468 16.739 18.9738 16.807 19.0858 16.891C19.1978 16.973 19.2878 17.076 19.3558 17.2C19.4258 17.324 19.4608 17.479 19.4608 17.665C19.4608 17.847 19.4298 18.019 19.3678 18.181C19.3078 18.341 19.2188 18.483 19.1008 18.607C18.9828 18.729 18.8378 18.829 18.6658 18.907C18.4958 18.983 18.3018 19.028 18.0838 19.042L18.0478 19.522C18.0458 19.564 18.0288 19.602 17.9968 19.636C17.9648 19.672 17.9238 19.69 17.8738 19.69H17.6338L17.6848 19.033C17.4488 19.005 17.2288 18.943 17.0248 18.847C16.8228 18.749 16.6498 18.627 16.5058 18.481L16.7008 18.184C16.7188 18.158 16.7418 18.137 16.7698 18.121C16.7998 18.103 16.8318 18.094 16.8658 18.094C16.9078 18.094 16.9528 18.111 17.0008 18.145C17.0508 18.179 17.1088 18.219 17.1748 18.265C17.2408 18.309 17.3188 18.353 17.4088 18.397C17.4988 18.439 17.6048 18.47 17.7268 18.49L17.8378 17.035C17.6978 16.993 17.5588 16.946 17.4208 16.894C17.2848 16.84 17.1618 16.769 17.0518 16.681C16.9438 16.593 16.8558 16.483 16.7878 16.351C16.7218 16.219 16.6888 16.053 16.6888 15.853C16.6888 15.703 16.7178 15.557 16.7758 15.415C16.8358 15.273 16.9218 15.147 17.0338 15.037C17.1478 14.925 17.2878 14.834 17.4538 14.764C17.6198 14.692 17.8098 14.651 18.0238 14.641L18.0538 14.239C18.0558 14.195 18.0728 14.156 18.1048 14.122C18.1368 14.088 18.1778 14.071 18.2278 14.071H18.4678L18.4228 14.659C18.6328 14.689 18.8148 14.747 18.9688 14.833C19.1228 14.917 19.2568 15.015 19.3708 15.127L19.2148 15.367C19.1708 15.437 19.1168 15.472 19.0528 15.472C19.0228 15.472 18.9868 15.461 18.9448 15.439C18.9048 15.417 18.8568 15.391 18.8008 15.361C18.7468 15.331 18.6848 15.301 18.6148 15.271C18.5448 15.241 18.4668 15.218 18.3808 15.202L18.2788 16.54Z"
          className="icon-primary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.231 15.3446C11.2365 15.2227 10.1403 15.1738 8.997 15.1738C4.684 15.1738 1 15.8538 1 18.5738C1 21.2948 4.661 21.9988 8.997 21.9988C10.8789 21.9988 12.641 21.8696 14.0296 21.4978C12.7849 20.3984 12 18.7905 12 16.9993C12 16.4253 12.0806 15.8702 12.231 15.3446Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
